import {
  Card,
  CardHeader,
  CardSection,
  CondensedLarge,
  Gutter,
  SmallHeader,
} from '@axiom/ui';
import React from 'react';

import type { PositionDescriptionSection } from './direct-engagements.types';

interface DirectEngagementsFormSummaryProps {
  positionDescription: PositionDescriptionSection[];
}

export const DirectEngagementsFormSummary: React.FC<
  DirectEngagementsFormSummaryProps
> = ({ positionDescription }) => {
  return (
    <Card name="direct-engagement-summary">
      <CardHeader>
        <SmallHeader name="SUMMARY_TITLE">Legal needs summary</SmallHeader>
      </CardHeader>
      <CardSection>
        {positionDescription.length > 0 ? (
          <CondensedLarge name="SUMMARY_CONTENT">
            {positionDescription.map(section => (
              <React.Fragment key={section.name}>
                {section.type === 'paragraph' && (
                  <Gutter bottom="16px">
                    <div data-test={section.name}>{section.content}</div>
                  </Gutter>
                )}

                {section.type === 'bulletList' && (
                  <>
                    {section.header ? (
                      <div data-test="SUMMARY_BULLET_HEADER">
                        {section.header}
                      </div>
                    ) : null}
                    <ul>
                      {(section.content as string[]).map(bullet => (
                        <li key={bullet} data-test="SUMMARY_BULLET_POINTS">
                          <div>{bullet}</div>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </React.Fragment>
            ))}
          </CondensedLarge>
        ) : (
          <CondensedLarge name="SUMMARY_EMPTY_STATE">
            Share your legal needs and we will prepare a summary.
          </CondensedLarge>
        )}
      </CardSection>
    </Card>
  );
};
